import { Component } from '@angular/core';

@Component({
  selector: 'i-microphone',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144" fill="none">
      <g clip-path="url(#clip0_3484_28038)">
        <path
          d="M45.4167 8.75008C52.1214 2.04532 61.4452 -1.33325 72 -1.33325C82.5548 -1.33325 91.8786 2.04532 98.5833 8.75008C105.288 15.4548 108.667 24.7787 108.667 35.3334V57.3334C108.667 67.8882 105.288 77.212 98.5833 83.9168C91.8786 90.6215 82.5548 94.0001 72 94.0001C61.4452 94.0001 52.1214 90.6215 45.4167 83.9168C38.7119 77.212 35.3333 67.8882 35.3333 57.3334V35.3334C35.3333 24.7787 38.7119 15.4548 45.4167 8.75008ZM13.3333 50.0001C17.3929 50.0001 20.6667 53.2739 20.6667 57.3334C20.6667 73.6763 25.8262 86.3525 34.4167 94.9168C43.0071 103.481 55.6571 108.667 72 108.667C88.3429 108.667 101.019 103.507 109.583 94.9168C118.148 86.3263 123.333 73.6763 123.333 57.3334C123.333 53.2739 126.607 50.0001 130.667 50.0001C134.726 50.0001 138 53.2739 138 57.3334C138 76.8453 131.767 93.5025 119.955 105.288C109.662 115.581 95.6762 121.631 79.3333 123.019V138C79.3333 142.06 76.0595 145.333 72 145.333C67.9405 145.333 64.6667 142.06 64.6667 138V123.019C48.3238 121.631 34.3381 115.581 24.0452 105.288C12.2595 93.5025 6 76.8191 6 57.3334C6 53.2739 9.27381 50.0001 13.3333 50.0001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3484_28038">
          <rect width="144" height="144" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconMicrophone {}
